import React from 'react'
import ReportComp from '../components/ReportComp'


export default function Report() {
  return (
    <>
    <ReportComp/>
    </>
  )
}
